import React from "react";
import InfoSection from "../../common/InfoSection";
import FeaturesGrid from "../../common/FeatureGrid";

function ProblemSolved({features}) {
  return (
    <div className="bg-whiteSmoke/40 w-full">
      <div className="max-w-1200 mx-auto w-full">
        <div className="px-4 sm:px-6 lg:px-0 py-8">
          <div className="flex flex-col gap-8">
            <InfoSection
              subtitle="Key Problems Solved by RegTechFlow"
              width="max-w-full"
            />
            <FeaturesGrid features={features} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProblemSolved;
